import { useApi } from "../../../hooks/useApi";
import { useCallback } from "react";
import { ICustomPayment, IProduct, IServicePayment, ISubscriptionPayment } from "../types";
import { urlReplacer } from "../../../utils";
import { ApiRoutes } from "../../../constants/apiRoutes";

export default function () {
  const { request } = useApi();
  return {
    fetchProducts: useCallback(async () => {
      return request({
        method: "GET",
        url: `${ApiRoutes.PRODUCTS}`,
      });
    }, [request]),

    createCheckoutSession: useCallback(
      async (product: IProduct, recaptchaToken: string) => {
        return request({
          data: { id: product.id },
          method: "POST",
          url: `${ApiRoutes.MAKE_PAYMENT}`,
          recaptchaToken,
        });
      },
      [request],
    ),

    createCustomCheckoutSession: useCallback(
      async (customPayment: ICustomPayment, recaptchaToken: string) => {
        return request({
          data: customPayment,
          method: "POST",
          url: `${ApiRoutes.MAKE_CUSTOM_PAYMENT}`,
          recaptchaToken,
        });
      },
      [request],
    ),

    createServiceCheckoutSession: useCallback(
      async (servicePayment: IServicePayment, recaptchaToken: string) => {
        return request({
          data: servicePayment,
          method: "POST",
          url: `${ApiRoutes.MAKE_SERVICE_PAYMENT}`,
          recaptchaToken,
        });
      },
      [request],
    ),

    createSubscriptionCheckoutSession: useCallback(
      async (
        subscriptionPayment: ISubscriptionPayment,
        recaptchaToken: string,
      ) => {
        return request({
          data: subscriptionPayment,
          method: "POST",
          url: `${ApiRoutes.MAKE_SUBSCRIPTION_PAYMENT}`,
          recaptchaToken,
        });
      },
      [request],
    ),

    cancelSubscription: useCallback(
      async (data: { token: string }) => {
        return request({
          data,
          method: "PUT",
          url: `${ApiRoutes.CANCEL_SUBSCRIPTION}`,
        });
      },
      [request],
    ),

    fetchMyPackage() {
      return request({
        method: "GET",
        url: `${ApiRoutes.GET_PACKAGE}`,
      });
    },

    fetchMyPaymentsHistory() {
      return request({
        method: "GET",
        url: `${ApiRoutes.GET_PAYMENTS_HISTORY}`,
      });
    },

    fetchPackage(id) {
      return request({
        method: "GET",
        url: urlReplacer(ApiRoutes.GET_USER_PACKAGE, { id }),
      });
    },

    fetchPaymentsHistory(id) {
      return request({
        method: "GET",
        url: urlReplacer(ApiRoutes.GET_USER_PAYMENTS_HISTORY, { id }),
      });
    },
  };
}
